import ContentHeader from "../../components/content-header/ContentHeader";
import React, { Component, useEffect, useState } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import Select from "react-select";
import {
  getAllOEM,
  getOEMDetails,
} from "../../services/data-service/oem-service";
import {
  getAllStates,
  getDistrictByState,
} from "../../services/data-service/master-service";
import { 
  addNewDealer, 
  getDealerDetails,
  updateDealerDetails
 } from "../../services/data-service/dealer-service";
import { getAuth, getRandom3 } from "../../services/common/utils";
import { toast } from "react-toastify";
import { FcPrevious } from "react-icons/fc";
import {
  Container,
  Row,
  Col,
  Form as BootstrapForm,
  Button,
} from "react-bootstrap";
import { FaRegPlusSquare } from "react-icons/fa";
import PageLoader from "../../components/PageLoader";

const cityOptions = [
  { value: "new", label: "new" },
  { value: "inprogress", label: "inprogress" },
  { value: "delivered", label: "delivered" },
  { value: "aborted", label: "aborted" },
];

const AddDealer = () => {
  const navigate = useNavigate();
  const { userid, user, role } = getAuth();
  const [loading, setLoading] = useState(false);
  const [districtLoading, setDistrictLoading] = useState(true)
  const {id} = useParams()
  const [addDealerDetails, setAddDealerDetails] = useState({    
    states: [],
    selectedState: "",
    districts: [],
    selectedDistrict: "",    
    selectedOEM: "",
    loginid: "",
    oemListOptions: [],
    paymentOption: 1,
    paymentType: "",
    is_prepaid: true,
    creditLimit: 0,
  });  
  const [errDealer, setErrDealer] = useState([])
  const [getDealerDetail, setGetDealerDetail] = useState()
  // console.log('errDealer', errDealer)
  // console.log(getDealerDetail)
  // console.log(addDealerDetails.districts)
  // console.log('addDealerDetails', addDealerDetails)

  async function fetchDropDownData(){ 
    setGetDealerDetail('')
    addDealerDetails.selectedOEM = ''
    addDealerDetails.selectedState = ''
    addDealerDetails.selectedDistrict = ''   
    addDealerDetails.districts = []
    setLoading(true)   
    await getAllOEM().then((response) => {
      const { oemListOptions } = addDealerDetails;
      response.data.map(
        (item) =>
          oemListOptions.push({
            value: item.id,
            label: item.oem_name,
          })        
      );
    });

    await getAllStates()
    .then((response) => {      
      const { states } = addDealerDetails;
      response.data.map(
        (item) =>
          states.push({
            value: item.id,
            label: item.state,
          })        
      );
      if(!id){
        setLoading(false) 
      }                  
    })
    .catch((error) => {
      console.log(error);
    });
        
    if(id){      
      getDealerDetails(id).then((response)=>{        
        if(response.status === 200){          
          let assignDealer = response?.data
          addDealerDetails.selectedOEM = assignDealer.oem_id
          addDealerDetails.selectedState = assignDealer.state_id
          addDealerDetails.selectedDistrict = assignDealer.district_id                  
          setGetDealerDetail(assignDealer)                                                                                         
          if (assignDealer.state_id && assignDealer.district_id && assignDealer.oem_id) {                                    
            onStateChanged(assignDealer.state_id)
            onDistrictChanged(assignDealer.district_id)
            onOEMChanged(assignDealer.oem_id)            
          }else{
            setLoading(false)
          }          
        }        
      })
    } 
  }

  useEffect(() => {
    fetchDropDownData()        
  }, [id]);

  async function onOEMChanged(oemId) {
    addDealerDetails.selectedOEM = oemId;    
    await getOEMDetails(oemId).then((response) => {
      addDealerDetails.is_prepaid = response.data.is_prepaid      
    });
  }

  function handleSubmit(event) {
    event.preventDefault();
    const data = event.target.elements;
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    const phoneRegex = /^[0-9]\d{9}$/;    
    const pinRegex = /^[0-9]\d{5}$/;
    const gstRegex = /^[0-9]{2}[A-Z]{5}[0-9]{4}[A-Z]{1}[1-9A-Z]{1}Z[0-9A-Z]{1}$/;


    if(!data.dealerName.value.trim().length > 0){
      toast.error( "Dealer Name is required")
      return;      
    }    
    else if (!phoneRegex.test(data.contactNumber.value.trim())){
      toast.error( "Invalid mobile number. Must be 10 digits")
      return;
    }
    else if (!emailRegex.test(data.emailID.value.trim())) {
      toast.error("Invalid email address")
      return;
    }
    else if (!gstRegex.test(data.gstNO.value.trim())) {
      toast.error("Invalid GST Number format. GST Number Format is 07ABCDE1234F2Z6")
      return;
    }
    else if (!addDealerDetails.selectedOEM) {
      toast.error("Select the OEM")
      return;
    }
    else if (!addDealerDetails.selectedState) {
      toast.error("Select the state")
      return;
    }
    else if (!addDealerDetails.selectedDistrict) {
      toast.error("Select the district")
      return;
    }
    else if (!data.city.value.trim().length > 0) {
      toast.error( "City is required")
      return;
    }
    else if (!pinRegex.test(data.pincode.value.trim())) {
      toast.error("Invalid pincode. Must be 6 digits")
      return;
    }
    else if (!data.address.value.trim().length > 0) {
      toast.error("Address is required")
      return;
    }
   
    const payload = {
      dealer_name: data.dealerName.value.trim(),
      dealer_mobile: data.contactNumber.value.trim(),
      dealer_email: data.emailID.value.trim(),
      oem: addDealerDetails.selectedOEM,
      dealer_gstno: data.gstNO.value.trim(),
      dealer_pincode: data.pincode.value.trim(),
      dealer_state: addDealerDetails.selectedState,
      dealer_district: addDealerDetails.selectedDistrict,
      dealer_city: data.city.value.trim(),
      dealer_address: data.address.value.trim(),
      is_prepaid: addDealerDetails.is_prepaid,      
    };  
    
    // console.log(payload)
    if(id){
      payload.id = id
      // console.log(payload)
      updateDealerDetails(payload)
      .then((response) => {       
        if(response.data.status === 'success'){                 
          toast.success(response.data.message);         
          navigate("/dealers");
        }else if (response.data.status === 'error'){
          if(Array.isArray(response?.data?.message)){
            setErrDealer(response?.data?.message) 
          }else{
            toast.error(response?.data?.message)
          }                              
        }         
      })
      .catch((error) => {
        toast.error("some error occured")
      });
    }else{
      addNewDealer(payload)
      .then((response) => {       
        if(response.data.status === 'success'){                
          toast.success(response.data.message);          
          navigate("/dealers");
        }else if (response.data.status === 'error'){
          if(Array.isArray(response?.data?.message)){
            setErrDealer(response?.data?.message) 
          }else{
            toast.error(response?.data?.message)
          }                              
        }         
      })
      .catch((error) => {
        toast.error("some error occured")
        // console.log(error, 'akk');
      });
    }    
  }

  async function onStateChanged(stateId) {
    setDistrictLoading(true)
    addDealerDetails.districts = []
    addDealerDetails.selectedState = stateId;        
    await getDistrictByState(stateId)
      .then((response) => {        
        const { districts } = addDealerDetails;
        response.data.map((item) =>
          districts.push({
              value: item.id,
              label: item.district,
            })
          )     
      })
      .catch((error) => {
        console.log(error);
      })
      .finally(()=>{
        setLoading(false)
        setDistrictLoading(false)
      })
  }

  function onCreditLimitChange(creditLimit) {
    // console.log(creditLimit);
    setAddDealerDetails({ ...addDealerDetails, creditLimit: creditLimit });
  }

  function onDistrictChanged(districtId) {    
    addDealerDetails.selectedDistrict = districtId    
  }

  return (
    <div>
      <ContentHeader title={id ? 'Edit Dealer' : 'New Dealer'} />
      <section className="content">
        <div className="container-fluid">
          <div className="card">
            <div className="card-header">
              {/* <div className="card-title d-flex flex-row justify-content-between">
                <span>
                  {id ? 'Edit Dealer' : 'New Dealer'}   
                </span>
                 <span>
                  <FcPrevious /> 
                </span>                                                           
              </div> */}
              <div className="card-title d-flex justify-content-between align-items-center w-100">
                <span>
                  {id ? 'Edit Dealer' : 'New Dealer'}
                </span>
                {                  
                  <Link to={`/oems`}>                
                    <span>
                      <FcPrevious 
                        fontSize="22px"
                      />
                    </span>
                  </Link>
                }
                
              </div>
            </div>
            <div className="card-body">
              {
                loading ? 
                <PageLoader/> :
                <section className="content">
                  <form
                    id="quickForm"
                    noValidate="novalidate"
                    onSubmit={handleSubmit}
                  >
                    <Container fluid>
                    
                      <div className="card card-primary">
                        {/* /.card-header */}
                        <div className="card-body">
                          {/* form start */}
                          {/* <form id="quickForm" noValidate="novalidate"> */}
                          <Row>
                          
                            <Col md={4}>
                              <BootstrapForm.Group>
                                <label htmlFor="dealerName">Dealer Name</label>
                                <input
                                  type="text"
                                  name="text"
                                  defaultValue={getDealerDetail?.dealer_name}
                                  className="form-control"
                                  id="dealerName"
                                  placeholder="Dealer Name"
                                />
                                {errDealer.length > 0 && errDealer.filter(item => item.field === 'dealer_name').length > 0 && (
                                  <p className="text-danger">
                                    {errDealer.find(item => item.field === 'dealer_name')?.message}
                                  </p>
                                )}
                              </BootstrapForm.Group>
                            </Col>
                            <Col md={4}>
                              <BootstrapForm.Group>
                                {role === "admin" && (
                                  <>
                                    <label htmlFor="embosingCenter">
                                      OEM (
                                      <Link to="/new-oem">
                                        <i className="fas fa-plus"></i> Create New
                                      </Link>
                                      )
                                    </label>
                                    {addDealerDetails.oemListOptions.length > 0 ? (
                                      <Select
                                        isDisabled={id ? true : false}
                                        className="select2bs4"
                                        defaultValue={                                        
                                          addDealerDetails.oemListOptions.find((item)=>item.value === getDealerDetail?.oem_id)                                        
                                        }
                                        style={{ width: "100%" }}
                                        options={
                                          addDealerDetails.oemListOptions.length >
                                          0
                                            ? addDealerDetails.oemListOptions
                                            : []
                                        }
                                        onChange={(e) => onOEMChanged(e.value)}                                        
                                      ></Select>
                                    ) : (
                                      <div className="overlay">
                                        <i className="fas fa-2x fa-sync fa-spin"></i>
                                      </div>
                                    )}
                                    {errDealer.length > 0  && errDealer.filter(item => item.field === 'oem').length > 0 && (
                                      <p className="text-danger">
                                        {errDealer.find(item => item.field === 'oem')?.message}
                                      </p>
                                    )}
                                  </>
                                )}
                              </BootstrapForm.Group>
                            </Col>
                            <Col md={4}>
                              <BootstrapForm.Group>
                                <label htmlFor="city">City</label>
                                <input
                                  type="text"
                                  defaultValue={getDealerDetail?.city}
                                  name="text"
                                  className="form-control"
                                  id="city"
                                  placeholder="City"
                                />
                                {errDealer.length > 0 && errDealer.filter(item => item.field === 'dealer_city').length > 0 && (
                                  <p className="text-danger">
                                    {errDealer.find(item => item.field === 'dealer_city')?.message}
                                  </p>
                                )}
                              </BootstrapForm.Group>
                            </Col>
                          </Row>
                          <Row>
                            <Col md={4}>
                              <BootstrapForm.Group>
                                <label htmlFor="contactNumber">
                                  Contact Number
                                </label>
                                <input
                                  type="number"
                                  defaultValue={getDealerDetail?.dealer_mobile}
                                  name="text"
                                  className="form-control"
                                  id="contactNumber"
                                  placeholder="Contact No"
                                />
                                {errDealer.length > 0 && errDealer.filter(item => item.field === 'dealer_mobile').length > 0 && (
                                  <p className="text-danger">
                                    {errDealer.find(item => item.field === 'dealer_mobile')?.message}
                                  </p>
                                )}
                              </BootstrapForm.Group>
                            </Col>

                            <Col md={4}>
                              <BootstrapForm.Group>
                                <label htmlFor="paymentOption">
                                  Payment Type
                                </label>
                                <input
                                  type="text"
                                  name="text"
                                  className="form-control"
                                  id="paymentType"
                                  value={
                                    addDealerDetails.is_prepaid
                                      ? "Prepaid"
                                      : "Postpaid"
                                  }
                                  disabled
                                />
                              </BootstrapForm.Group>
                            </Col>

                            <Col md={4}>
                              <BootstrapForm.Group>
                                <label htmlFor="pincode">PinCode</label>
                                <input
                                  type="number"
                                  defaultValue={getDealerDetail?.pincode}
                                  name="text"
                                  className="form-control"
                                  id="pincode"
                                  placeholder="Pincode"
                                />
                                {errDealer.length > 0 && errDealer.filter(item => item.field === 'dealer_pincode').length > 0 && (
                                  <p className="text-danger">
                                    {errDealer.find(item => item.field === 'dealer_pincode')?.message}
                                  </p>
                                )}
                              </BootstrapForm.Group>
                            </Col>
                          </Row>
                          <Row>
                            <Col md={8}>
                              <Row>
                                <Col md={6}>
                                  <BootstrapForm.Group>
                                    <label htmlFor="emailID">Email Address</label>
                                    <input
                                      type="email"
                                      defaultValue={getDealerDetail?.dealer_email}
                                      name="text"
                                      className="form-control"
                                      id="emailID"
                                      placeholder="Email ID"
                                    />
                                    {errDealer.length > 0 && errDealer.filter(item => item.field === 'dealer_email').length > 0 && (
                                      <p className="text-danger">
                                        {errDealer.find(item => item.field === 'dealer_email')?.message}
                                      </p>
                                    )}
                                  </BootstrapForm.Group>
                                </Col>
                                <Col md={6}>
                                  <BootstrapForm.Group>
                                    <label htmlFor="inState">State</label>
                                    {addDealerDetails.states.length > 0 ? (
                                      <Select
                                        className="select2bs4"
                                        defaultValue={
                                          addDealerDetails.states.find(
                                            (item) => item?.label === getDealerDetail?.state
                                          )
                                          // (() => {  
                                          //   const selectedState = addDealerDetails.states.find(
                                          //     (item) => item?.label === getDealerDetail?.state
                                          //   );                                            
                                          //   if (selectedState) {
                                          //     onStateChanged(selectedState.value);
                                          //   }
                                          //   return selectedState;
                                          // })
                                        }                                        
                                        style={{ width: "100%" }}
                                        options={
                                          addDealerDetails.states.length > 0
                                            ? addDealerDetails.states
                                            : []
                                        }
                                        onChange={(e) => onStateChanged(e.value)}
                                      ></Select>
                                    ) : (
                                      <div className="overlay">
                                        <i className="fas fa-2x fa-sync fa-spin"></i>
                                      </div>
                                    )}
                                    {errDealer.length > 0 && errDealer.filter(item => item.field === 'dealer_state').length > 0 && (
                                      <p className="text-danger">
                                        {errDealer.find(item => item.field === 'dealer_state')?.message}
                                      </p>
                                    )}
                                  </BootstrapForm.Group>
                                </Col>
                              </Row>
                              <Row>
                                <Col md={6}>
                                  <BootstrapForm.Group>
                                    <label htmlFor="gstNO">GST Number</label>
                                    <input
                                      type="text"
                                      defaultValue={getDealerDetail?.gst_no}
                                      name="text"
                                      className="form-control"
                                      id="gstNO"
                                      placeholder="GST"
                                    />
                                    {errDealer.length > 0 && errDealer.filter(item => item.field === 'dealer_gstno').length > 0 && (
                                      <p className="text-danger">
                                        {errDealer.find(item => item.field === 'dealer_gstno')?.message}
                                      </p>
                                    )}
                                  </BootstrapForm.Group>
                                </Col>
                                <Col md={6}>
                                  <BootstrapForm.Group>
                                    <label htmlFor="district">District</label>
                                    <Select
                                     isDisabled={districtLoading}
                                      className="select2bs4"                                                                            
                                      defaultValue={                                        
                                        addDealerDetails.districts.find((item)=>item.label === getDealerDetail?.district)                                                                               
                                      }
                                      style={{ width: "100%" }}
                                      options={addDealerDetails.districts}
                                      onChange={(e) => onDistrictChanged(e.value)}
                                    ></Select>
                                    
                                    {errDealer.length > 0 && errDealer.filter(item => item.field === 'dealer_district').length > 0 && (
                                      <p className="text-danger">
                                        {errDealer.find(item => item.field === 'dealer_district')?.message}
                                      </p>
                                    )}
                                  </BootstrapForm.Group>
                                </Col>
                              </Row>
                            </Col>
                            <Col md={4}>
                              <BootstrapForm.Group>
                                <BootstrapForm.Label>Address</BootstrapForm.Label>
                                <textarea
                                  className="form-control"
                                  id="address"
                                  defaultValue={getDealerDetail?.dealer_address}
                                  rows="4"
                                />
                                {errDealer.length > 0 && errDealer.filter(item => item.field === 'dealer_address').length > 0 && (
                                  <p className="text-danger">
                                    {errDealer.find(item => item.field === 'dealer_address')?.message}
                                  </p>
                                )}
                                </BootstrapForm.Group>
                            </Col>                            
                          </Row>

                          {/* {this.state.paymentOption === "1" && (
                                  <div className="form-group">
                                    <label htmlFor="loginID">Credit Limit</label>
                                    <input
                                      type="text"
                                      name="text"
                                      className="form-control"
                                      id="creditLimit"
                                      onChange={(e) =>
                                        this.onCreditLimitChange(e.target.value)
                                      }
                                    />
                                  </div>
                                )} */}
                          {/* </div> */}
                          {/* Right */}
                          {/* <div className="col-md-4"> */}
                          {/* <div className="form-group">
                                  <label htmlFor="embosingCenter">
                                    Embossing Center (<Link to="/add-embosing-station"> <i className="fas fa-plus"></i> Create New </Link>)
                                  </label>
                                  <input
                                    type="text"
                                    name="text"
                                    className="form-control"
                                    id="embosingCenter"
                                    placeholder="Embosing Center"
                                  />
                                </div> */}

                          {/* </div> */}

                          {/* </form> */}
                        </div>
                        {/* /.card-body */}
                        <div className="card-footer">
                          <button
                            type="submit"
                            className="btn btn-primary float-right"
                          >
                            Submit
                          </button>
                        </div>
                      </div>
                      {/* /.card */}
                    
                      
                    </Container>

                    {/* /.container-fluid */}
                  </form>
                </section>
              }              
            </div>
            {/* <div className="card-footer">Footer</div> */}
          </div>
        </div>
      </section>
    </div>
  );
};

export default AddDealer;
